import { useMemo } from 'react'

import {
  formatRewardRequestPartnerMeta,
  resolveRewardRequestPartnerMeta
} from '@/features/store/lib/resolveRewardRequestMeta'
import { useGamificationDataStore } from '@/shared/store/gamificationDataStore'

export const DigitalProductStoreBottomSheetRewardRequestItemLabel = ({
  quantity,
  rewardItem
}) => {
  const partners = useGamificationDataStore(
    state => state.getActiveProductData().partners
  )

  const partnerNameById = useMemo(
    () =>
      Object.fromEntries(
        partners.map(partner => [String(partner.id), partner.name])
      ),
    [partners]
  )

  const metaLine = formatRewardRequestPartnerMeta(
    resolveRewardRequestPartnerMeta(rewardItem, partnerNameById)
  )

  return (
    <div className="min-w-0 flex-1">
      <span className="block text-sm font-bold">
        {quantity}x {rewardItem?.name}
      </span>
      {metaLine ? (
        <span className="mt-0.5 block text-2xs font-semibold leading-snug text-gray-700 line-clamp-2">
          {metaLine}
        </span>
      ) : null}
    </div>
  )
}
